import { baseUrl } from '../config';
// Set the base URL for API requests
const BASE_URL = baseUrl;
// Set the API request timeout
// If an environment variable `REACT_APP_API_TIMEOUT` is defined, use that value (converted to integer)
// Otherwise, default to 30,000 milliseconds (30 seconds)
const TIMEOUT = process.env.REACT_APP_API_TIMEOUT
  ? parseInt(process.env.REACT_APP_API_TIMEOUT, 10)
  : 30000;

// Centralized configuration for API endpoints and settings
export const API_CONFIG = {
  BASE_URL,
  TIMEOUT,
  ENDPOINTS: {
    AUTH: {
      LOGIN: "/auth/login",
    },
    MATERIAL: {
      GET_ALL: "/material/get_all",
      CREATE: "/material/create",
      GET_NAME: "/material/name",
      SOFT_DELETE: (material_master_id) => `/material/soft_delete/${material_master_id}`,
      UPDATE_MATERIAL: (material_master_id) => `/material/update/${material_master_id}`,
    },
    INBOND: {
      CREATE: "/inbond/create",
      GET_ALL: "/inbond/get_all",
      GET_BI_NUMBER: "/inbond/get_binumber",
      SOFT_DELETE_COMPLETE: (inbond_master_id) => `/inbond/soft_delete_complete/${inbond_master_id}`,
      SOFT_DELETE_PARTIAL: (inbond_child_id) => `/inbond/soft_delete_partial/${inbond_child_id}`,
      UPDATE_COMPLETE: (inbond_master_id) => `/inbond/update_complete/${inbond_master_id}`,
      UPDATE_PARTIAL: (inbond_child_id) => `/inbond/update_partial/${inbond_child_id}`,
      GET_ALL_BI_NUMBER: "/inbond/get_all_binumber",
      GET_EDIT_DETAILS: (inbond_master_id,inbond_child_id) => `/inbond/get_edit_details?inbond_master_id=${inbond_master_id}&inbond_child_id=${inbond_child_id}`,
      GET_INBOND_EDIT_ENTRY_DETAILS: () => `/inbond/edit_entry_details`,
    },
    SECTIONS: {
      CREATE: "/section/create",
      GET_ALL: "/section/get_all",
      SOFT_DELETE: (section_master_id) => `/section/soft_delete/${section_master_id}`,
      UPDATE_SECTION: (section_master_id) => `/section/update/${section_master_id}`,
    },
    EXBOND: {
      CREATE: "/exbond/create",
      GET_ALL: "/exbond/get_all",
      GET_MATERIAL_INBOND_DATE: (inbond_master_id) => `/exbond/get_material_inbond_bedate?inbond_master_id=${inbond_master_id}`,
      GET_INBOND_WEIGHT_DUTY: (inbond_child_id) => `/exbond/get_weight_duty_test?inbond_child_id=${inbond_child_id}`,
      SOFT_DELETE_COMPLETE: (exbond_master_id) => `/exbond/soft_delete_complete/${exbond_master_id}`,
      SOFT_DELETE_PARTIAL: (exbond_child_id) => `/exbond/soft_delete_partial/${exbond_child_id}`,
      UPDATE_COMPLETE: (exbond_master_id) => `/exbond/update_complete/${exbond_master_id}`,
      GET_EDIT_DETAILS: (exbond_master_id,exbond_child_id) => `/exbond/get_edit_details?exbond_master_id=${exbond_master_id}&exbond_child_id=${exbond_child_id}`,
      GET_EXBOND_EDIT_ENTRY_DETAILS: () => `/exbond/edit_entry_details`,
    },
    DUTY_SPACE: {
      GET_ALL_DUTY_SPACE_TOTAL: "/duty_space/get_duty_total",
      CREATE_ADJUSTMENTS: (inbond_master_id) => `/duty_space/create_adjustment?inbond_master_id=${inbond_master_id}`,
    },
    CUSTOMERS: {
      GET_ALL: "/customer/get_all",
      CREATE: "/customer/create",
      SOFT_DELETE: (customer_master_id) => `/customer/soft_delete/${customer_master_id}`,
      UPDATE_CUSTOMER: (customer_master_id) => `/customer/update/${customer_master_id}`,
    },
    DISPATCH: {
      CREATE: "/dispatch/create",
      GET_ALL: "/dispatch/get_all",
      GET_ALL_BE_NUMBER: "/dispatch/benumber",
      GET_ALL_EXBOND_LIST: (exbond_child_id) => `/dispatch/get_exbond?exbond_child_id=${exbond_child_id}`,
      SOFT_DELETE_COMPLETE: (dispatch_master_id) => `/dispatch/soft_delete_complete/${dispatch_master_id}`,
      SOFT_DELETE_PARTIAL: (dispatch_child_id) => `/dispatch/soft_delete_partial/${dispatch_child_id}`,
      UPDATE_COMPLETE: (dispatch_master_id) => `/dispatch/update_complete/${dispatch_master_id}`,
      GET_EDIT_DETAILS: (dispatch_master_id,dispatch_child_id) => `/dispatch/get_edit_details?dispatch_master_id=${dispatch_master_id}&dispatch_child_id=${dispatch_child_id}`,
      GET_INBOND_FULL_DATA: (inbond_master_id) => `/dispatch/inbond-full-data/${inbond_master_id}`,
      GET_BI_NUMBER: "/dispatch/get_bi_number",
      GET_EXBOND_NUMBER: "/dispatch/get_exbond_number",
      GET_EBOND_DISPATCH_DATA: (exbond_master_id) => `/dispatch/get_exbond_dispatch_data?exbond_master_id=${exbond_master_id}`,
    },
    REPORTS: {
      GET_TOTAL_QUANTITY_INBIND_EXBOND: "/reports/total_quantity_inbond_exbond",
      GET_TOTAL_QUANTITY_INBOND_EXBOND_MATERIALWISE: "/reports/total_quantity_inbond_exbond_materialwise",
      GET_BALANCE_DUTY_EXBOND: "/reports/balance_duty_exbond",
      GET_BALANCE_DUTY_DISPATCH: "/reports/balance_duty_dispatch",
      GET_DUTY_PENDING_EXBOND:"/reports/duty_pending_exbond",
      GET_DUTY_PAID_PENDING_DISPATCH: "/reports/duty_paid_pending_dispatch"
    }
  },
};

// Function to get request headers
// `includeAuth` determines whether to include the Authorization token
export const getHeaders = (includeAuth = false) => {
  const headers = {
    "Content-Type": "application/json",
  };

  if (includeAuth) {
    const token = sessionStorage.getItem("authToken");
    
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }
  }

  return headers;
};

export const refreshAccessToken = async () => {
  try {
    const refreshToken = sessionStorage.getItem("refreshToken");

    if (!refreshToken) {
      console.error("No refresh token found!");
      return null;
    }

    // Build headers
    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${refreshToken}`,
    };

    // Call refresh endpoint
    const res = await fetch(`${API_CONFIG.BASE_URL}/auth/refresh`, {
      method: "POST",
      headers: headers,
    });

    if (!res.ok) {
      console.error("Refresh token request failed:", res.status);
      return null;
    }

    const data = await res.json();

    // Save new access token
    sessionStorage.setItem("authToken", data.data.access_token);

    return data.data.access_token;  // return new token so caller can retry API

  } catch (err) {
    console.error("Refresh token failed:", err);
    return null;
  }
};

